import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./header.css";
import { Container, Image } from "react-bootstrap";
import bgr from "../assets/images/r-bg.png";
import { useNavigate } from "react-router-dom";
import whitelogo from "../assets/images/white-logo.png";
import logo from "../assets/images/MTDlogo.png";
import { useEffect, useState } from "react";
import arrow from "../assets/images/arrow.png";
import { InstallApp } from "./InstallApp/InstallApp";

// Custom hook for responsive behavior
const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    width: typeof window !== 'undefined' ? window.innerWidth : 1200
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        isMobile: width <= 768,
        isTablet: width > 768 && width <= 1024,
        isDesktop: width > 1024,
        width: width
      });
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export const Headerlp = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop, width } = useResponsive();
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close menu when screen size changes
  useEffect(() => {
    if (!isMobile) {
      setMenuOpen(false);
    }
  }, [isMobile]);

  const goToSignup = () => {
    navigate("/signup");
  };

  const goToSignin = () => {
    navigate("/Signinoptions");
  };

  return (
    <div className='header-main'>
      <div className='header-content'>
        <div className='bg-l'>
          <div className='header-shade'></div>
        </div>

        {/* Mobile Navigation */}
        {isMobile && (
          <div className="navbar-custom">
            <div onClick={toggleMenu} className="menu-icon">
              <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12.715H18.6M1 7.08798H18.6M1 1.46094H18.6" stroke="#F1E9E9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            {menuOpen && (
              <div className="menubarformob">
                <Link className={pathname === "/" ? "active-link" : ""} to="/" onClick={toggleMenu}>Home</Link>
                <Link className={pathname === "/SuccessPage" ? "active-link" : ""} to="/SuccessPage" onClick={toggleMenu}>Success Stories</Link>
                <Link className={pathname === "/aboutus" ? "active-link" : ""} to="/aboutus" onClick={toggleMenu}>About Us</Link>
                <a href="https://tamilculture.com/user/mytamildatecom" onClick={toggleMenu}>Blogs</a>
                <Link className={pathname === "/GetInTouch" ? "active-link" : ""} to="/GetInTouch" onClick={toggleMenu}>Contact Us</Link>
              </div>
            )}
          </div>
        )}

        {/* Mobile Logo */}
        <img
          width="310px"
          src={whitelogo}
          className='mobile-logo'
          alt="Mobile Logo"
          loading="lazy"
        />

        <div className='header-text'>
          <img
            src={logo}
            className='main-logo'
            alt="Main Logo"
            loading="lazy"
          />

          <span>
            Meet Tamil<br />
            Singles
          </span>

          <Container className='header-btn'>
            <button className='header-btnone' onClick={goToSignup}>
              Get Started
            </button>

            {/* Responsive button rendering */}
            {isMobile ? (
              <a
                href="#"
                className="header-link"
                onClick={(e) => {
                  e.preventDefault();
                  goToSignin();
                }}
              >
                Returning? Login
              </a>
            ) : (
              <button className="header-btntwo" onClick={goToSignin}>
                Returning? Login
              </button>
            )}
            <InstallApp />
          </Container>
        </div>

        <div className='bg-r'>
          <Image
            src={bgr}
            style={{ height: '100%', width: '100%' }}
            alt="Background Image"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};
